import { render, staticRenderFns } from "./taxAdditionsList.vue?vue&type=template&id=65073c66&"
import script from "./taxAdditionsList.vue?vue&type=script&lang=js&"
export * from "./taxAdditionsList.vue?vue&type=script&lang=js&"
import style0 from "./taxAdditionsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer})
